angular.module('lf.common')

.directive('passwordsMustMatch', function () {
  return {
    require: '^form',
    link: function (scope, el, attrs, FormCtrl) {
      var $newPassword = el.find('.input_new-password');
      var $confirmNewPassword = el.find('.input_confirm-new-password');
      var $errorMessage = el.find('.error-message_passwords-must-match');
      var newPasswordInputName = $newPassword.attr('name');
      var confirmNewPasswordInputName = $confirmNewPassword.attr('name');
      var newPasswordModel = FormCtrl[newPasswordInputName];
      var confirmNewPasswordModel = FormCtrl[confirmNewPasswordInputName];
      var watchValues = attrs.passwordsMustMatch;
      
      scope.$watch(watchValues, function (values) {
        var newPassword = values[0];
        var confirmNewPassword = values[1];
        
        if (newPassword && confirmNewPassword) {
          
          var valid = newPassword === confirmNewPassword;
          newPasswordModel.$setValidity('passwordsMustMatch', valid);
          confirmNewPasswordModel.$setValidity('passwordsMustMatch', valid);
          
          if (valid) {
            if (_.isEmpty(newPasswordModel.$error)) {
              $newPassword.parent().removeClass('has-error');
            }
            if (_.isEmpty(confirmNewPasswordModel.$error)) {
              $confirmNewPassword.parent().removeClass('has-error');
            }
          } else {
            $newPassword.parent().addClass('has-error');
            $confirmNewPassword.parent().addClass('has-error');
          }
        }
      });
      
    }
  }
});
